import {TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Paper, Grid, Box} from '@mui/material';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {DateTime} from 'luxon';
import {dStr, tStr, unixNow} from './Util.js';
import ObsAppBar from './AppBar.js';
import {COMM_OK} from './WsR2.js';

const BWTFRow = (props) => {
	let d_str, t_str, time;

	time = props.obs.start_t;
	d_str = dStr(time);
	if (d_str === dStr(unixNow()))
		d_str = '';

	t_str = tStr(time);
	if (t_str.length > 0 && t_str !== '0:00')
		d_str += ' ' + t_str;

	const desc = props.obs.num + ' (' + props.obs.sum_desc + ')';
	
	return (
		<TableRow key={props.obs.id} style={{backgroundColor: '#ffffff', '& > *': { borderBottom: 'unset' }}}>
			<>
				<TableCell sx={{minWidth: 100,padding: 2, margin: 1}}>{props.obs.taxon}</TableCell>
				<TableCell sx={{minWidth: 30, padding: 2, margin: 1}}>{d_str}</TableCell>
				{/*<TableCell sx={{minWidth: 180, padding: 2, margin: 1}}>{a_str}</TableCell>*/}
				<TableCell sx={{minWidth: 60, padding: 2, margin: 1}} align='right'>{desc}</TableCell>
			</>
		</TableRow>
	)
}

const BWTFTable = (props) => {
	const {t} = useTranslation('obs');

	return (
		<TableContainer component={Paper} elevation={0}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell size='small' sx={{minWidth: 100}}>{t('main.species')}</TableCell>
						<TableCell size='small' sx={{minWidth: 30}} >{t('main.time')}</TableCell>
						{/*<TableCell size='small' sx={{minWidth: 180}}>{t('main.location')}</TableCell>*/}
						<TableCell size='small' sx={{minWidth: 60}} align='right'>{'Määrä'}</TableCell>
					</TableRow>
				</TableHead>

				<TableBody>
				{
					props.obslist.map((obs, ind) => {
						obs.id = props.obslist.length - ind;
						return <BWTFRow key={ind} obs={obs} />
					})
				}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

const BWTF = (props) => {
	const [obslist, setObsList]  = useState([]);
	const [listVal, setListVal] = useState('');
	const [remVal, setRemVal] = useState('');
	const gStorage = useGlobalStorage();

	function bwtfCountSpecies(obslist) {
		let a = [];
		
		obslist.forEach((e) => {
			const found = a.findIndex((ae) => {
				// console.log(ae, e.taxon, ae === e.taxon);
				return ae === e.taxon;
			});
			
			if (found < 0) {
				a.push(e.taxon);
			}
		})

		return a.length;
	}

	function bwtfCountIndi(obslist) {
		let n = 0;
		
		obslist.forEach((e) => {
			n += e.num;
		})

		return n;
	}
	
	function bwtfGetListVal(obslist) {
		let str = obslist.length + ' havaintoa, ';

		str += bwtfCountSpecies(obslist) + ' lajia, ';
		str += bwtfCountIndi(obslist) + ' yksilöä.';

		return str;
	}
	
	function bwtfRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('bwtfRxWs: error ', status);
			return -1;
		}

		// console.log('bwtfRxWs', msg);

		if (msg.cmd === 'anonymous') {
			if (msg.op === 'tt2026list') {
				if (msg.result === 'OK') {
					if (msg.data.tt2026list) {
						setObsList(msg.data.tt2026list);
						setListVal(bwtfGetListVal(msg.data.tt2026list));
					} else {
						setObsList([]);
						setListVal(bwtfGetListVal([]));
					}
				} else {
					console.error('bwtfRxWs: tt2026 query failed! Result: ', msg.result);
				}
			} else {
				console.error('bwtfRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('bwtfRxWs: unknown command', msg.cmd, msg.op, msg.result);
		}
	}

	function loadObs() {
		// console.log('loadObs', gStorage.conn.connected, gStorage.conn.online);

		if (!gStorage.conn.connected)
			return;

		let msg = {
			sess_id: '',
			cmd: 'anonymous',
			op: 'tt2026list',
			data: {
			},
		}

		gStorage.conn.ws.send(msg, bwtfRxWs);
	}

	function bwtfMkStartString() {
		const currD = DateTime.now().toUnixInteger();
		const startD = DateTime.local(2026, 5, 9, 5, 0).toUnixInteger();
		// const startD = 1778158440;
		// console.log('Start', startD);

		const remSec = startD - currD;

		if (remSec <= 0)
			return '';

		const remDays = Math.floor(remSec / (24 * 3600));
		const remRemSec = remSec - (remDays * 24*3600);

		const remHours = Math.floor(remRemSec / 3600);
		const remRemRemSec = remRemSec - (remHours * 3600);

		const remMins = Math.floor(remRemRemSec / 60);
		const finalSecs = remRemRemSec % 60;

		let str = 'TT 2026 alkaa ';

		// console.log('Event taking place in', remDays, 'days', remHours, 'hours', remMins, 'minutes', finalSecs, 'seconds.');

		if (remDays) {
			str += remDays + ' päivän';
		}

		if (remHours) {
			if (!remMins && !finalSecs)
				str += ' ja '
			else if (remDays)
				str += ', ';

			str += remHours + ' tunnin';
		}

		if (remMins) {
			if (!finalSecs)
				str += ' ja '
			else if (remDays || remHours)
				str += ', ';

			str += remMins + ' minuutin';
		}

		if (finalSecs) {
			if (remDays || remHours || remMins)
				str += ' ja ';

			str += finalSecs + ' sekunnin'
		}

		str += ' kuluttua.';

		// console.log(str);

		return str;
	}

	let updCounter = 0;
	
	function updateView() {
		const remStr = bwtfMkStartString();

		setRemVal(remStr);
// 		console.log('updCounter', updCounter);

		if (!remStr.length) {
			if (updCounter % 5 === 0) {
				loadObs();
			}
			
			if (gStorage.conn.connected)
				updCounter++;
		}
	}

	useEffect(() => {
		updateView();

		const id = setInterval(updateView, 1000);

		return () => {
			clearInterval(id);
		};
		// eslint-disable-next-line
	}, []);

	function getheader() {
		return 'Tornien taisto 2026 - Kortejärvi Urjala';
	}

	const remVisible = remVal.length ? 'block' : 'none';
	const listVisible = remVisible === 'none' ? 'block' : 'none';

	return (
		<>
			<ObsAppBar getheader={getheader} />

			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<Box sx={{p: 6, display: remVisible}}>{remVal}</Box>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<Box sx={{p: 6, display: listVisible}}>{listVal}</Box>
				</Grid>

				<Grid size={{xs: 12}} align={'center'}>
					<div style={{display: listVisible}}>
						<BWTFTable obslist={obslist} />
					</div>
				</Grid>
			</Grid>
		</>
	);
};

export default BWTF;
